import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IBusinessFicaUploadedFileResponse } from '../models/business-fica-files.model';
import { fromBusinessFicaFileActions } from '../actions';

export const businessFicaFileFeatureKey = 'businessFicaFile';

export interface BusinessFicaFileState {
  loadBusinessFicaFileResponse: IBusinessFicaUploadedFileResponse[];
  loadBusinessFicaFileFailure: IGenericError<ErrorResponse>;
}

export const initialState: BusinessFicaFileState = {
  loadBusinessFicaFileResponse: undefined,
  loadBusinessFicaFileFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromBusinessFicaFileActions.loadBusinessFicaFilesSuccess, (state, action) => ({
    ...state,
    loadBusinessFicaFileResponse: action.response
  })),
  on(fromBusinessFicaFileActions.loadBusinessFicaFilesFailure, (state, action) => ({
    ...state,
    loadBusinessFicaFileFailure: action.error
  }))
);

export const getBusinessFicaFileResponse = (state: BusinessFicaFileState) => state.loadBusinessFicaFileResponse;
export const getBusinessFicaFileFailure = (state: BusinessFicaFileState) => state.loadBusinessFicaFileFailure;
